'use client'

import React from 'react'
// import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
// import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { getQueryClient } from './get-query-client'
import { QueryClientProvider } from '@tanstack/react-query'

// const persister = createSyncStoragePersister({
//   storage: typeof window === "undefined" ? null : window.localStorage,
// });

export const ServicesProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const queryClient = getQueryClient()
  return (
    <QueryClientProvider
      client={queryClient}
      // persistOptions={{ persister }}
    >
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
    </QueryClientProvider>
  )
}
